import { render, staticRenderFns } from "./BFormV2.vue?vue&type=template&id=1f2363f1&scoped=true&"
import script from "./BFormV2.vue?vue&type=script&lang=js&"
export * from "./BFormV2.vue?vue&type=script&lang=js&"
import style0 from "./BFormV2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BFormV2.vue?vue&type=style&index=1&id=1f2363f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2363f1",
  null
  
)

export default component.exports